(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      this.syncSettledState();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    syncSettledState() {
      if (document.body.classList.contains('template-product')) return;

      /* toggle(name, force) leaves the attribute alone when nothing changes; add/remove rewrite it
         on every scroll event, which wakes every MutationObserver on the page */
      const settled = (window.pageYOffset || document.documentElement.scrollTop) > 30;
      this.classList.toggle('is-settled', settled);
      this.classList.toggle('scrolled', settled);
    }

    onScroll() {
      if (document.body.classList.contains('template-product')) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop <= 0) {
        this.classList.toggle('is-fixed', false);
      } else if (scrollTop > this.currentScrollTop) {
        this.classList.toggle('is-fixed', false);
      } else if (scrollTop < this.currentScrollTop) {
        this.classList.toggle('is-fixed', true);
      }

      this.syncSettledState();
      this.currentScrollTop = scrollTop;
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
